<template>
  <div class="empty_wrap" :style="'height:' + h">
    <img src="~@/assets/images/common/loading-bubbles.svg" alt="">
    <p>{{tips || $t('hardLoading')}}</p>
  </div>
</template>

<script>

export default {
  props: {
    tips: {
      type: String
    },
    h: {
      type: String
    }
  },
  created () {
    let body = document.body
    let mask = document.createElement('div')
    mask.id = 'yioks_mask'
    body.appendChild(mask)
  },
  destroyed () {
    let body = document.body
    let mask = document.getElementById('yioks_mask')
    body.removeChild(mask)
  }
}
</script>

<style lang="stylus" scoped>
  .empty_wrap
    height 100%
    display flex
    justify-content center
    align-items center
    flex-direction column
    img
      margin-top -.2rem
    p
      margin-top .2rem
</style>
